export default [
  'gh-map-high-street',
  'gh-map-enjoyment',
  'gh-map-greenspace',
  'gh-map-education',
];
